// MIRRORS: panel/components/emptyState/emptyState.tsx — identical copy; edit both, or delete this line on both to declare a deliberate split.
import type { ComponentType } from 'react';
import type { LucideProps } from 'lucide-react';
import styles from './emptyState.module.scss';

interface Props {
  icon: ComponentType<LucideProps>;
  title: string;
  body: string;
  /** Only for empties the user caused and can undo — e.g. "clear the search". */
  action?: { label: string; onClick: () => void };
}

/**
 * An empty result is not an error, and the two must not look alike.
 *
 * The distinction that matters: "there is nothing here" (a healthy system —
 * no banned users is good news) versus "your filter excluded everything" (a
 * dead end the user can back out of). The second gets an `action`; the first
 * does not, because there is nothing to undo.
 */
export function EmptyState({ icon: Icon, title, body, action }: Props) {
  return (
    <div className={styles.empty}>
      <span className={styles.icon} aria-hidden>
        <Icon size={26} />
      </span>
      <p className={styles.title}>{title}</p>
      <p className={styles.body}>{body}</p>
      {action && (
        <button type="button" className={styles.action} onClick={action.onClick}>
          {action.label}
        </button>
      )}
    </div>
  );
}
